import { render, staticRenderFns } from "./BlockBannerText.vue?vue&type=template&id=2325d0f6&scoped=true&"
import script from "./BlockBannerText.vue?vue&type=script&lang=ts&"
export * from "./BlockBannerText.vue?vue&type=script&lang=ts&"
import style0 from "./BlockBannerText.vue?vue&type=style&index=0&id=2325d0f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2325d0f6",
  null
  
)

export default component.exports